import { render, staticRenderFns } from "./WidgetConfigurator.vue?vue&type=template&id=c6fb45c2&scoped=true"
import script from "./WidgetConfigurator.vue?vue&type=script&lang=js"
export * from "./WidgetConfigurator.vue?vue&type=script&lang=js"
import style0 from "./WidgetConfigurator.vue?vue&type=style&index=0&id=c6fb45c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6fb45c2",
  null
  
)

export default component.exports